/*
   State machine para coordinar el ciclo de vida de la reserva.

   Reemplaza dos flags module-level sueltos (`releaseInProgress`,
   `skipUnloadRelease`) y sus 6 helpers, por una pieza de estado nombrada y
   mutuamente excluyente. Más un guard adicional para evitar checkouts
   concurrentes contra el gateway.

   Estados:
   - 'idle'        → default. El beforeunload libera la reserva normalmente.
   - 'releasing'   → lock anti-doble: el caller programó un release vía
                     useReserve.release(); el beforeunload no debe duplicarlo.
   - 'skip-unload' → redirect intencional al gateway externo (Allaria). El
                     beforeunload NO debe liberar — queremos que la reserva
                     sobreviva hasta que el user vuelva del checkout hosted
                     y el polling del frontend o el worker la consuma vía
                     confirmarCompra.
*/

type LifecycleState = 'idle' | 'releasing' | 'skip-unload';

let state: LifecycleState = 'idle';
let checkoutInFlight = false;

export const reserveLifecycle = {
    is: (s: LifecycleState) => state === s,
    set: (s: LifecycleState) => { state = s; },

    /*
       Guard global para checkout al gateway externo. Persiste entre mounts
       del componente: si el user toca Allaria → back → Allaria rápido,
       el segundo mount ve que ya hay un request en flight y no arranca otro.
       Evita crear dos Compras en DB para la misma reserva.
    */
    isCheckoutInFlight: () => checkoutInFlight,
    markCheckoutInFlight: () => { checkoutInFlight = true; },
    clearCheckoutInFlight: () => { checkoutInFlight = false; },

    reset: () => {
        state = 'idle';
        checkoutInFlight = false;
    },
};
